export function getVBind(portal_id) {
  var vBind = {
    alwaysUpdate: true,
    addButtonCaption: "Add Tariff",
    newItemTitle: "New Tariff",
    title: "My Tariffs",
    data_object: {
      step_type: "Table",
      object_name: "tariff_list",
      getFreshData: true,
      // hideTitle: true,
      get_table: "all",
      table: [],
      step: 2,
      portal_id: portal_id,
      table_title: "My Tariffs",
      hasSearch: false,
      aggregate: {
        local_collection: "tariff_list",
        name: "tariff_list",
        qry: {},
        select_fields: {
          _id: "$_id",
          tariff_name: "$tariff_name",
          charge_category: "$charge_category"
          // haul_type: "$haul_type",
          // order_type: "$order_type",

          //haul_type: "$reduce: {input: $haul_type, initialValue: \"haul_type\", in: { $haul_type : [\"$$value\", \"$$this\"] }         }"
        }
      }
      // add_only: true,
      // editable: [
      //   { name: "labor_unit", ctl: "v-text-field", "x-type": "string" },
      //   { name: "unit_rate", ctl: "v-text-field", "x-type": "number" },
      //   { name: "num_men", ctl: "v-text-field", "x-type": "number" },
      //   { name: "num_truck", ctl: "v-text-field", "x-type": "number" },
      //   { name: "max_volume", ctl: "v-text-field", "x-type": "number" },
      //   { name: "max_stairs", ctl: "v-text-field", "x-type": "number" },
      // ],
    }
  };
  return vBind;
}
